module.exports = __webpack_public_path__ + "static/media/eyelashes03.12637b66.jpg";